// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__9u3Z5","list":"BalanceDue_list__csCAR","listRow":"BalanceDue_listRow__ufoOL","total":"BalanceDue_total__12wr5"};